import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import BootLoader from "@/components/BootLoader";
import MarketingLayout from "@/layouts/MarketingLayout";
import PortalLayout from "@/layouts/PortalLayout";
import { PortalAuthProvider } from "@/portal/PortalAuth";
import LandingPage from "@/pages/LandingPage";
import ContactPage from "@/pages/ContactPage";
import ServicesPage from "@/pages/ServicesPage";
import AppsIndexPage from "@/pages/AppsIndexPage";
import AppLandingPage from "@/pages/AppLandingPage";
import ValuesPage from "@/pages/ValuesPage";
import PartnersPage from "@/pages/PartnersPage";
import TeamPage from "@/pages/TeamPage";
import AboutPage from "@/pages/AboutPage";
import FaqPage from "@/pages/FaqPage";
import AppPage from "@/pages/AppPage";
import PortalLoginPage from "@/pages/portal/LoginPage";
import PortalOtpPage from "@/pages/portal/OtpPage";
import PortalSignupPage from "@/pages/portal/SignupPage";
import PortalDashboardPage from "@/pages/portal/DashboardPage";
import PortalListsPage from "@/pages/portal/ListsPage";
import PortalListDetailPage from "@/pages/portal/ListDetailPage";
import PortalTemplatesPage from "@/pages/portal/TemplatesPage";
import PortalCampaignsPage from "@/pages/portal/CampaignsPage";
import PortalSmtpPage from "@/pages/portal/SmtpPage";

export default function App() {
  return (
    <BootLoader>
      <BrowserRouter>
        <PortalAuthProvider>
          <Routes>
            <Route path="portal/login" element={<PortalLoginPage />} />
            <Route path="portal/otp" element={<PortalOtpPage />} />
            <Route path="portal/signup" element={<PortalSignupPage />} />

            <Route path="portal" element={<PortalLayout />}>
              <Route index element={<PortalDashboardPage />} />
              <Route path="lists" element={<PortalListsPage />} />
              <Route path="lists/:id" element={<PortalListDetailPage />} />
              <Route path="templates" element={<PortalTemplatesPage />} />
              <Route path="campaigns" element={<PortalCampaignsPage />} />
              <Route path="settings/smtp" element={<PortalSmtpPage />} />
            </Route>

            <Route element={<MarketingLayout />}>
              <Route index element={<LandingPage />} />
              <Route path="services" element={<ServicesPage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="apps" element={<AppsIndexPage />} />
              <Route path="apps/:slug" element={<AppLandingPage />} />
              <Route path="values" element={<ValuesPage />} />
              <Route path="partners" element={<PartnersPage />} />
              <Route path="team" element={<TeamPage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="faq" element={<FaqPage />} />
              <Route path="app" element={<AppPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </PortalAuthProvider>
      </BrowserRouter>
    </BootLoader>
  );
}
